import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './ReportNews.css';

export default function Article() {
  const [articles, setArticles] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get('https://ppmn.net/dash/api/main/mqalat')
      .then((res) => {
        setArticles(Array.isArray(res.data) ? res.data.slice(0, 3) : []);
      })
      .catch((err) => console.error('فشل في جلب المقالات:', err));
  }, []);

  return (
    <div className="report-container container py-5">
      <h3 className="mb-4 pb-2 section-title">مقالات</h3>

      <div className="row">
        {articles.map((article) => (
          <div
            key={article.article_id}
            className="col-lg-4 col-md-6 mb-4"
            onClick={() =>
              navigate(`/News/mqalat/${article.article_id}/${article.article_slug}`)
            }
            style={{ cursor: 'pointer' }}
          >
            <div className="report-box d-flex shadow-sm rounded h-100">
              <img
                src={article.article_title_image}
                alt={article.article_title}
                className="report-img"
              />
              <div className="report-content ms-3 d-flex flex-column justify-content-between w-100">
                <div>
                  <h5 className="report-title" style={{ lineHeight: '1.5', fontSize: '18px' }}>
                    {article.article_title}
                  </h5>
                </div>
                <div
                  className="d-flex justify-content-between align-items-center text-muted mt-auto"
                  style={{ fontSize: '13px' }}
                >
                  <span>{article.user_name}</span>
                  <span>
                    <i className="far fa-clock ms-1 mt-1"></i>
                    {article.article_published_before}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
